import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../styles/CalendarAvailability.css';

const monthNames = [
  "Январь", "Февраль", "Март", "Апрель", "Май", "Июнь",
  "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"
];

const CalendarAvailability = ({ carId, onSelectDates }) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const [year, setYear] = useState(today.getFullYear());
  const [month, setMonth] = useState(today.getMonth() + 1);
  const [availability, setAvailability] = useState({});
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  useEffect(() => {
    const fetchAvailability = async () => {
      try {
        const response = await axios.get(`/api/cars/${carId}/availability/?year=${year}&month=${month}`);
        setAvailability(response.data);
      } catch (err) {
        console.error('Ошибка при получении доступности:', err);
      }
    };
    fetchAvailability();
  }, [carId, year, month]);

  const handlePrevMonth = () => {
    setMonth(prev => (prev === 1 ? 12 : prev - 1));
    if (month === 1) {
      setYear(prev => prev - 1);
    }
  };

  const handleNextMonth = () => {
    setMonth(prev => (prev === 12 ? 1 : prev + 1));
    if (month === 12) {
      setYear(prev => prev + 1);
    }
  };

  const handleDateClick = (date) => {
    const dateObj = new Date(date);
    if (dateObj < today) return;

    if (!startDate) {
      setStartDate(date);
      setEndDate(null);
    } else if (!endDate && new Date(date) > new Date(startDate)) {
      setEndDate(date);
      // **Передаем диапазон включительно**
      onSelectDates(startDate, date);
    } else {
      setStartDate(date);
      setEndDate(null);
    }
  };

  // --- Новый блок: передача дней в родителя для отображения
  useEffect(() => {
    if (startDate && endDate) {
      // Можно посчитать дни тут (для UI)
      const start = new Date(startDate);
      const end = new Date(endDate);
      const days = Math.floor((end - start) / (1000 * 60 * 60 * 24)) + 1; // включительно
      // Можно сделать callback: onSelectDates(startDate, endDate, days)
      if (onSelectDates) onSelectDates(startDate, endDate, days);
    }
  }, [startDate, endDate]); // eslint-disable-line

  return (
    <div className="calendar-container">
      <h4 className="calendar-title">Выберите даты для аренды</h4>
      <div className="calendar-header">
        <button onClick={handlePrevMonth} className="month-button">◀</button>
        <span className="month-title">{monthNames[month - 1]} {year}</span>
        <button onClick={handleNextMonth} className="month-button">▶</button>
      </div>
      <div className="calendar">
        {Object.keys(availability).map(dateKey => {
          const dateObj = new Date(dateKey);
          let dayClass = availability[dateKey] === "red" ? "booked" : "available";
          if (dateObj < today) {
            dayClass = "past-date";
          } else {
            if (startDate === dateKey) dayClass = "start-date";
            if (endDate === dateKey) dayClass = "end-date";
            if (startDate && endDate && dateObj >= new Date(startDate) && dateObj <= new Date(endDate)) {
              dayClass = "selected-range";
            }
          }
          return (
            <div
              key={dateKey}
              className={`calendar-day ${dayClass}`}
              title={dateKey}
              onClick={() => handleDateClick(dateKey)}
            >
              {dateObj.getDate()}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CalendarAvailability;
